import { useCallback } from 'react';

import { IMAGE_FILE_KEY_FIELD } from 'approot/shared/stimulus/form-fields/stimulus-form-fields.constants';
import { useFindComponentDimensions } from '../component.hooks';
import { useFileDropperContext } from 'lib/form/file-dropper/file-dropper';
import { FileDropperImage } from 'lib/form/file-dropper/file-dropper-image';
import { ACCEPT_TYPE_IMAGE } from 'lib/form/file-dropper/file-dropper.constants';
import { EditProps } from './image-sphere.constants';
import * as Styled from '../image/image.style';

const ImageSphereCreate = (
  props: EditProps & {
    onShowModal: (props: { key: string; fileName: string; file: File }) => void;
  }
) => {
  const { onShowModal } = props;

  const { elementDimensionLabel } = useFindComponentDimensions(props.id);
  const { clearFile } = useFileDropperContext(IMAGE_FILE_KEY_FIELD);

  const handleFileChange = useCallback(
    (key: string, fileName: string, file: File | undefined) => {
      if (file) {
        clearFile();
        onShowModal({ key, fileName, file });
      }
    },
    [clearFile, onShowModal]
  );

  return (
    <Styled.ImageCreateFieldWrapper>
      <FileDropperImage
        placeholder="Drag and drop your 360° image file here"
        name={IMAGE_FILE_KEY_FIELD}
        inputDataSelector={IMAGE_FILE_KEY_FIELD}
        accept={[ACCEPT_TYPE_IMAGE]}
        isFinishing={false}
        additionalLabel={elementDimensionLabel}
        onChange={handleFileChange}
      />
    </Styled.ImageCreateFieldWrapper>
  );
};

export default ImageSphereCreate;
